exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n    color: black;\n    font-family: 'Montserrat', sans-serif;\n}", ""]);

// exports
